import { z } from 'zod'
import { DirectoEventResponseStatusEnum } from '../../../../../api/models/directo-event-response'

const DirectoFormSchema = z.object({
  id: z.number().optional(),
  customerId: z.number().positive(),
  descriptionAddendum: z.string().optional(),
  status: z.enum([
    DirectoEventResponseStatusEnum.IDLE,
    DirectoEventResponseStatusEnum.QUEUED,
    DirectoEventResponseStatusEnum.SUBMITTED,
    DirectoEventResponseStatusEnum.ERROR,
    DirectoEventResponseStatusEnum.FAILED,
  ]),
})

export type DirectoFormValues = z.infer<typeof DirectoFormSchema>

export default DirectoFormSchema
